import { PocButton, PocIcon } from 'commons/components/components-wrapper';

type AddButtonProps = {
    text: string;
    onClick: VoidFunction;
    disabled?: boolean;
};

export const AddButton = ({ text, onClick, disabled = false }: AddButtonProps) => (
    <PocButton variant="tertiary" size="medium" onClick={onClick} disabled={disabled}>
        <PocIcon slot="prefix" name="circle_add" status="info" />
        {text}
    </PocButton>
);
